export default __webpack_public_path__ + "static/media/featBgMb.9d88bba0.jpg";